import { Link } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import './Portal.css'

const quickMenuItems = [
  { path: '/patients', icon: 'person', label: '患者カルテ', description: '患者情報の閲覧・登録' },
  { path: '/reservations', icon: 'calendar_month', label: '移植予約カレンダー', description: '予約の確認・登録' },
  { path: '/medical-records', icon: 'description', label: '診療記録', description: '診療記録の作成' },
]

const statsData = [
  { label: '今月の移植件数', value: '24', unit: '件', trend: '+3' },
  { label: '予約待ち', value: '12', unit: '件', trend: null },
  { label: '登録患者数', value: '849', unit: '名', trend: '+15' },
]

const announcements = [
  {
    id: 1,
    date: '2025.11.28',
    title: '次回勉強会日が決まりましたらご報告いたします！',
    isNew: true,
  },
  {
    id: 2,
    date: '2025.11.12',
    title: '年末年始の発送につきまして',
    isNew: false,
  },
  {
    id: 3,
    date: '2025.08.08',
    title: '移植用高濃度NanoGASメリーにつきまして',
    isNew: false,
  },
  {
    id: 4,
    date: '2025.04.18',
    title: '腸内フローラバランス検査キットご注文に関するお願い',
    isNew: false,
  },
]

const recentActivities = [
  {
    id: 1,
    type: 'medical_record',
    content: '患者 KuKn 様の診療記録が作成されました',
    user: 'Baseクリニック赤坂',
    time: '2時間前',
  },
  {
    id: 2,
    type: 'reservation',
    content: '12/1 14:30 の移植予約が登録されました',
    user: '事務局（水谷恭子）',
    time: '3時間前',
  },
  {
    id: 3,
    type: 'board',
    content: '掲示板（正会員）に新しい投稿があります',
    user: '田中三紀子',
    time: '昨日',
  },
]

export default function Portal() {
  const user = useAuthStore((state) => state.user)

  return (
    <>
      <header className="aip-main__header">
        <div className="aip-main__header-container">
          <h1 className="aip-main__header-title">ポータル</h1>
        </div>
      </header>

      <div className="aip-main__content">
        <div className="portal-grid">
          {/* ウェルカムセクション */}
          <section className="portal-welcome">
            <h2>おはようございます、{user?.lastName}さん</h2>
            <p>腸内フローラ移植臨床研究会 管理システムへようこそ</p>
          </section>

          {/* 統計情報 */}
          <section className="portal-stats">
            {statsData.map((stat, index) => (
              <div key={index} className="portal-stat-card">
                <div className="portal-stat-label">{stat.label}</div>
                <div className="portal-stat-value">
                  {stat.value}
                  <span className="portal-stat-unit">{stat.unit}</span>
                </div>
                {stat.trend && (
                  <div className="portal-stat-trend portal-stat-trend--positive">
                    <span className="material-symbols-outlined">trending_up</span>
                    {stat.trend}
                  </div>
                )}
              </div>
            ))}
          </section>

          {/* クイックメニュー */}
          <section className="portal-section">
            <h3 className="portal-section-title">
              <span className="material-symbols-outlined">grid_view</span>
              クイックメニュー
            </h3>
            <div className="portal-quick-menu">
              {quickMenuItems.map((item) => (
                <Link key={item.path} to={item.path} className="portal-quick-menu-item">
                  <span className="material-symbols-outlined portal-quick-menu-icon">
                    {item.icon}
                  </span>
                  <div className="portal-quick-menu-content">
                    <div className="portal-quick-menu-label">{item.label}</div>
                    <div className="portal-quick-menu-description">{item.description}</div>
                  </div>
                  <span className="material-symbols-outlined portal-quick-menu-arrow">
                    chevron_right
                  </span>
                </Link>
              ))}
            </div>
          </section>

          {/* お知らせ */}
          <section className="portal-section">
            <h3 className="portal-section-title">
              <span className="material-symbols-outlined">campaign</span>
              研究会からのお知らせ
            </h3>
            <ul className="portal-announcements">
              {announcements.map((announcement) => (
                <li key={announcement.id} className="portal-announcement-item">
                  <span className="portal-announcement-date">{announcement.date}</span>
                  <span className="portal-announcement-title">
                    {announcement.isNew && <span className="portal-announcement-badge">NEW</span>}
                    {announcement.title}
                  </span>
                </li>
              ))}
            </ul>
            <Link to="#" className="portal-link">
              過去のアーカイブはこちら
              <span className="material-symbols-outlined">arrow_forward</span>
            </Link>
          </section>

          {/* 最近のアクティビティ */}
          <section className="portal-section">
            <h3 className="portal-section-title">
              <span className="material-symbols-outlined">history</span>
              最近のアクティビティ
            </h3>
            <ul className="portal-activities">
              {recentActivities.map((activity) => (
                <li key={activity.id} className="portal-activity-item">
                  <div className="portal-activity-icon">
                    <span className="material-symbols-outlined">
                      {activity.type === 'medical_record' && 'description'}
                      {activity.type === 'reservation' && 'event'}
                      {activity.type === 'board' && 'forum'}
                    </span>
                  </div>
                  <div className="portal-activity-content">
                    <div className="portal-activity-text">{activity.content}</div>
                    <div className="portal-activity-meta">
                      {activity.user} · {activity.time}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </section>

          {/* マニュアル */}
          <section className="portal-section">
            <h3 className="portal-section-title">
              <span className="material-symbols-outlined">menu_book</span>
              kintoneの使い方マニュアルはこちらから
            </h3>
            <div className="portal-manuals">
              <a href="#" className="portal-manual-card">
                <span className="portal-manual-number">1</span>
                <span className="portal-manual-title">kintoneでできること編</span>
              </a>
              <a href="#" className="portal-manual-card">
                <span className="portal-manual-number">2</span>
                <span className="portal-manual-title">患者登録の流れ・移植申込編</span>
              </a>
              <a href="#" className="portal-manual-card">
                <span className="portal-manual-number">3</span>
                <span className="portal-manual-title">移植の準備から症例報告まで編</span>
              </a>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}




